'use es6';

export const getMon606TextKeyBase = isVariant => isVariant ? 'mon606' : 'pricingPage';